import Swiper from 'swiper';
import { Autoplay, EffectCoverflow, Pagination } from 'swiper/modules';

class SliderHeaderHome {
  constructor() {
    this._init();
  }

  _init() {
    new Swiper('.slider-event__slider', {
      modules: [EffectCoverflow, Pagination, Autoplay], //Autoplay
      // effect: 'coverflow',
      // coverflowEffect: {
      //   rotate: 50,
      //   stretch: 0,
      //   depth: 100,
      //   modifier: 1,
      //   slideShadows: true
      // },
      // loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      speed: 1000,
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 0,
      grabCursor: true,
      preventInteractionOnTransition: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    });
  }
}

export const sliderHeaderHome = new SliderHeaderHome();
